export default { sha: 'b3309a418216875c292de8aff57894315ff499dc', buildNumber: 'undefined' }
